const BASE_URL = "https://bilduppladdning.webbland.nu"

export function mediaLibrary() {
    productPage();
    productList();
}

async function productPage() {
    if ($('.page-Product').length === 0) return;

    // Get the product code from class
    const productCode = $('.page-Product').attr('class').match(/prod-([A-Z0-9-]+)/)[1];

    // Fetch images from API
    const images = await $.ajax({
        url: `${BASE_URL}/api.php?name=${productCode}&rand=${Math.random()}`,
        method: 'GET',
        dataType: 'json',
        xhrFields: {
            withCredentials: false
        },
        cache: true
    });

    // images should be an array or object with count
    // For example: { count: 3, data: [...] }
    const $imageContainer = $('.product-images'); // adjust selector to your container
    $imageContainer.find('img').each(function(index) {
        const img = $(this);

        // Only replace if there’s a corresponding image from API
        if (index < images.count) {
            // Construct the new URL: BASE_URL + /SKU?order=?
            const newUrl = `${BASE_URL}/${productCode}?order=${index}`;
            img.attr('src', newUrl);
        }
    });

    $('.zoomWindow').css('background-image', `url(${BASE_URL}/${productCode})`)
}

function productList() {
    if ($('.page-Prodlist').length === 0) return;

    $('.page-Prodlist .prodlist .productContainer').each(function(index) {
        const $container = $(this);
        const href = $container.find('.itemnamelink').attr('href');
        const match = href ? href.match(/id=([A-Z0-9-]+)/) : null;
        if (!match) return;

        const productCode = match[1];

        // Delay image update (e.g., 200ms per item)
        setTimeout(() => {
            $container.find('.product-image').attr('src', `${BASE_URL}/${productCode}`);
            console.log('Updated:', productCode);
        }, index * 200);
    });
}
